import { privateClient } from '../../../api/axios';

const createBundle = (data) => privateClient.post('/create/assessmentbundle', data);

export default createBundle;
